import React, { useEffect } from 'react'
import Nav from '../components/nav/Nav';
import PromotionContainer from '../containers/Promotions';


const PromotionPage: React.FC= () => {

  useEffect(()=>{
    document.title = ''
  }, [])

  return (
    <div>
      <Nav />
      <PromotionContainer />
    </div>
  )
}

export default PromotionPage
